import { render, staticRenderFns } from "./IndexRedesign.vue?vue&type=template&id=6581cbd2"
import script from "./IndexRedesign.vue?vue&type=script&lang=js"
export * from "./IndexRedesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports